var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{staticClass:"ma-2",attrs:{"outlined":"","color":"green","to":"/"}},[_vm._v("Back")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }